module.exports = __webpack_public_path__ + "static/img/hk@2x.ff4e40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hk@2x.png
// module id = 3565
// module chunks = 1